export const validation = {
  name: 'Please enter industry name',
  nameMax:"Country name should be less than 50 words"
};
